import React,{useState,useEffect} from 'react';
var timer;
export default function CountDown(props) {
    const [minute, setminute] = useState(props.minute);
    const [seconds, setseconds] = useState(props.seconds);    

    useEffect(() => {
        let a = seconds,b = minute;
        timer = setInterval(()=>{
            if(a===0&&b===0) {
                clearInterval(timer);
                if(props.end) {
                    props.end();
                }
                return false;
            }
            if(a===0) {
                b-=1;
                setminute(b);
                a = 59;
                setseconds(a);
            } else {
                a -= 1;
                setseconds(a);
            }
        },1000);
        return () => {
            clearInterval(timer);
        };
    }, []);

    return (
        <div style={{display:'inline-block'}}>
            <i className="ico ico-time"></i><span className="highLight">{minute<10?'0':''}{minute}:{seconds<10?'0':''}{seconds}</span>
        </div>
    )
}